import { Directive, ViewContainerRef } from '@angular/core';

import { ActionBarComponent } from './action-bar.component';

@Directive({
    selector: '[action-bars]',
    standalone: false
})
export class ActionBarDirective {
  constructor(private viewContainerRef: ViewContainerRef) { }

  public createComponent(): ActionBarComponent
  {
    const componentRef =
        this.viewContainerRef.createComponent(ActionBarComponent);
    const component = componentRef.instance;
    component.componentRef = componentRef;
    const loaderComponentElement = component.nativeElement;
    const parent: Node = loaderComponentElement.parentNode;
    parent.insertBefore(loaderComponentElement, parent.firstChild);
    return component;
  }
}
